import React from 'react';
import { Button } from 'react-bootstrap';
import { InputField } from 'components/common/form/field/InputField';
import {
  CustomGeofenceComponentProps,
  CustomGeofenceComponentState
} from './CustomGeofenceComponentModel';
import styles from './customGeofenceComponent.module.scss';
import { InputGroupField } from 'components/common/form/field/InputGroupField';
import i18n from 'i18n';

export class CustomGeofenceComponent extends React.Component<
  CustomGeofenceComponentProps,
  CustomGeofenceComponentState
> {
  handler: number;

  constructor(props: CustomGeofenceComponentProps) {
    super(props);
    this.state = this.props.model.state;
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
  }

  componentDidUpdate(prevProps: CustomGeofenceComponentProps) {
    if (prevProps.model !== this.props.model) {
      prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
      this.setState(this.props.model.state);
    }
  }

  componentWillUnmount() {
    this.props.model.event.remove(this.handler);
  }

  handleLongitudeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.props.model.onLongitudeChange(value);
  };

  handleLatitudeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.props.model.onLatitudeChange(value);
  };

  handleRadiusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    this.props.model.onRadiusChange(value);
  };

  handleSave = () => {
    this.props.model.onSave();
  };

  handleClear = () => {
    this.props.model.onClear();
  };

  render() {
    return (
      <div className={styles.geofenceContainer}>
        <div className={styles.title}>
          {i18n.t('limitation.labels.customGeofence')}
        </div>
        <hr />
        <div className={styles.body}>
          <div className={styles.latlongGroup}>
            <div className={styles.inputGroup}>
              <InputField
                label={i18n.t('limitation.labels.latitude')}
                name='latitude'
                type='number'
                value={
                  this.state.latitude !== undefined
                    ? String(this.state.latitude)
                    : ''
                }
                onChange={this.handleLatitudeChange}
                className={styles.input}
                isFlexibleContent
                fieldContentWidth={160}
                step={0.0001}
                error={this.state.latitudeError}
              />
            </div>
            <div className={styles.inputGroup}>
              <InputField
                label={i18n.t('limitation.labels.longitude')}
                name='longitude'
                type='number'
                value={
                  this.state.longitude !== undefined
                    ? String(this.state.longitude)
                    : ''
                }
                onChange={this.handleLongitudeChange}
                className={styles.input}
                isFlexibleContent
                fieldContentWidth={160}
                step={0.0001}
                error={this.state.longitudeError}
              />
            </div>
          </div>
          <div className={styles.inputGroup}>
            <InputGroupField
              label={i18n.t('limitation.labels.radius')}
              name='radius'
              type='number'
              value={
                this.state.radius !== undefined ? String(this.state.radius) : ''
              }
              onChange={this.handleRadiusChange}
              className={styles.input}
              min={0}
              isFlexibleContent
              fieldContentWidth={320}
              postText='KM'
              step={0.1}
              error={this.state.radiusError}
            />
          </div>
        </div>
        <div className={styles.buttonArea}>
          <Button size='sm' variant='primary' onClick={this.handleSave}>
            {i18n.t('limitation.buttons.addDomain')}
          </Button>
          <Button size='sm' variant='secondary' onClick={this.handleClear}>
            {i18n.t('limitation.buttons.clear')}
          </Button>
        </div>
      </div>
    );
  }
}
